import { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { DocumentInterface, InterfaceContactUs } from '../../interfaces/Interfaces';
import ContactUsList from '../../api/ContactUsList.api';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux/store';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Spinner,
} from 'react-bootstrap';
import DocumentsApi from '../../api/Documents.api';
import DocumentUploadApi from '../../api/DocumentUpload.api';
import Swal from 'sweetalert2';
import DocumentRemoveApi from '../../api/DocumentRemove.api';

const Documents = () => {
  const dispatch = useDispatch<AppDispatch>(); // Type your dispatch

  const [list, setList] = useState<DocumentInterface[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [file,setFile] = useState<any>(null);

  const fetchDocuments = async () => {
    setLoading(true);
        await DocumentsApi()
        .then((response) => {
            const listInfoObject = response.data;
            setList(listInfoObject);
        })
        .finally(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        fetchDocuments();
    }, []);

    const onFileChange = (e) => {
        setFile(e.target.files[0])
    }

    const onFileUpload = async (e) => {
        const formData = new FormData();
        formData.append('doc', file);
        setUploading(true);
        DocumentUploadApi(formData).then((response) => {
            Swal.fire({
                title: 'Success!',
                text: 'Document has been uploaded successful. the url is : ' + response.data.docUrl,
                icon: 'success',
                confirmButtonText: 'Ok',
            });
            fetchDocuments()
        }).catch((error) => {
            throw new Error(error);
        }).finally(() =>{
            setFile(null)
            setUploading(false);
        });
    };

  const removeFile = (file : any) => {
      setDeleting(true)
      DocumentRemoveApi(file).then((response) => {
        Swal.fire({
            title: 'Success!',
            text: 'Document has been removed successful',
            icon: 'success',
            confirmButtonText: 'Ok',
        });
        fetchDocuments()
    }).catch((error) => {
        throw new Error(error);
    }).finally(() =>{
      setDeleting(false);
    });
  }

  return (
    <Card>
      <CardHeader className="fs-4 d-flex justify-content-between">
        <div>
            In this page you will find all documents
        </div>
        <div className='text-right'>
            <input type="file" className="" onChange={onFileChange} />
            <button onClick={onFileUpload} className="btn btn-primary" disabled={uploading}>
                {uploading ? 'Uploading...' : 'Upload!'}
            </button>
        </div>
      </CardHeader>
      <CardBody>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Document Name</th>
              <th>Document URL</th>
              <th>Document Remove</th>
            </tr>
          </thead>
          <tbody>
            {loading && !list && (
              <tr className="text-center">
                <td colSpan={3}>
                  <Spinner />
                </td>
              </tr>
            )}
            {!loading && list && list.length == 0 && (
              <tr className="text-center">
                <td colSpan={3}>No documents available</td>
              </tr>
            )}
            {list &&
              list.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.docName}</td>
                    <td>
                      <a href={item.docUrl} target='_blank'>{item.docUrl}</a>
                    </td>
                    <td>
                      <button disabled={deleting} className="btn btn-primary" onClick={() => {removeFile(item)}}>Remove File</button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default Documents;
